const normalizeString = (str) => str
  .toLowerCase()
  .normalize('NFKD')
  .replace(/\p{Diacritic}/gu, '')
  .split('')
  .map((ch) => {
    switch (ch) {
      case 'æ': return 'ae';
      case 'ı': return 'i';
      case 'ø': return 'o';
      case 'œ': return 'oe';
      case 'ß': return 'ss';
      default: return ch;
    }
  })
  .join('');

export { normalizeString };
